import { render, staticRenderFns } from "./view-stock-modal.vue?vue&type=template&id=4cbd7280&"
import script from "./view-stock-modal.vue?vue&type=script&lang=js&"
export * from "./view-stock-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports